import { getUnavailableDatesAndWeekDays } from './helpers/getUnavailableDatesAndWeekDays';

export function useWeekDayUnavailable(
  ...args: Parameters<typeof getUnavailableDatesAndWeekDays>
) {
  return getUnavailableDatesAndWeekDays(...args);
}
